import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import { SetStateAction } from "react";
import { IconEdit01 } from "@pentabd/icons";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  setIsUpdateModalOpen: (value: SetStateAction<boolean>) => void,
  setSelectedId: (value: SetStateAction<number | undefined>) => void,
) => {
  return [
    {
      id: 1,
      key: "shortForm",
      name: t("LEAVE_SETTINGS.TABLE.COLUMN.SHORT_FORM"),
      render: (shortForm: string) => <Text color="subtitle2">{shortForm}</Text>,
    },
    {
      id: 2,
      key: "name",
      name: t("LEAVE_SETTINGS.TABLE.COLUMN.EN_NAME"),
      render: (name: string) => <Text color="subtitle2">{name}</Text>,
    },
    {
      id: 3,
      key: "nameBn",
      name: t("LEAVE_SETTINGS.TABLE.COLUMN.BN_NAME"),
      render: (nameBn: string) => <Text color="subtitle2">{nameBn}</Text>,
    },
    {
      id: 4,
      key: "maxDuration",
      name: t("LEAVE_SETTINGS.TABLE.COLUMN.QUANTITY"),
      render: (maxDuration: string) =>
        maxDuration ? (
          <Text color="info" weight="semibold">
            {maxDuration}
          </Text>
        ) : (
          <Text color="subtitle2">...</Text>
        ),
    },
    {
      id: 5,
      key: "id",
      name: "",
      render: (id: number | string) => {
        return (
          <div
            onClick={() => {
              setIsUpdateModalOpen(true);
              setSelectedId(id as number);
            }}
            className="cursor-pointer"
          >
            <IconEdit01 size={24} fill="info" />
          </div>
        );
      },
    },
  ];
};
